



<mat-checkbox   *ngIf="canUserDisableSubject | async"
                [checked]="!(disabledSubject | async)"
                (change)="disabledSubject.next(!$event.checked)"
                color="primary"
></mat-checkbox>

<mat-form-field class="full-width" [ngClass]="{'readonly-wrapper':readOnlyObs | async}">

    <mat-label ssFormLabel></mat-label>
    <mat-select  [ngClass]="{'readonly-block':readOnlyObs | async}" [disabled]="(disabledSubject | async) || (readOnlyObs | async)" [value]="selectedValuesSubject | async" [multiple]="true" >

        <mat-select-trigger class="select-trigger" >
            <mat-chip-set >
                <mat-chip *ngFor="let item of selectedItemsSubject | async;trackBy:trackyByValue" >
                    {{item.text}}
                    <button matChipRemove (click)="setChecked(item.value,false)" *ngIf="!(readOnlyObs | async)"><mat-icon>cancel</mat-icon></button>
                </mat-chip>
            </mat-chip-set>
        </mat-select-trigger>

        <mat-option  *ngFor="let item of listItemsSelectedObs | async;trackBy:trackyByValue" [value]="item.value">
            {{item.text}}
        </mat-option>

    </mat-select>
    <mat-error ssFormValidationMessage></mat-error>

</mat-form-field>


